import { Button, ButtonProps } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import React from "react";

interface IButtonProps {
  text: string;
  title?: string;
  disabled?: boolean;
  style?: React.CSSProperties;
  variant?: ButtonProps["variant"];
  onClick?: () => void;
}

const DefaultButtonAdd: React.FC<IButtonProps> = ({
  text,
  title,
  style,
  disabled = false,
  variant,
  onClick,
}) => {
  return (
    <Button
      leftSection={<IconPlus size={16} />}
      style={{ ...style }}
      disabled={disabled}
      title={title}
      variant={variant}
      onClick={() => {
        onClick?.();
      }}
    >
      {text}
    </Button>
  );
};

export default DefaultButtonAdd;
